import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import ModalToBody from '../../../base/ModalToBody';
import { ajaxErrorHandler, defaultSuccess } from '../../../libs/utils';
import { PREFERENCES_ACTIONS } from '../../../redux/preferences/actions';
import { selectEvent, selectWeekend } from '../../../redux/preferences/selectors';
import { printerSettings } from '../../../redux/printers/selectors';
import { claimParkingStickers } from '../../../services/api/parkingVouchers';
import ParkingStickersVouchersAdvancedForm from './ParkingStickersVouchersAdvancedForm';
import ParkingStickersVouchersSearchForm from './ParkingStickersVouchersSearchForm';
import ParkingStickersVouchersStickerForm from './ParkingStickersVouchersStickerForm';

class _ParkingStickersVouchersSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeVoucher: undefined,
      crewMember: undefined,
    };

    this._setActiveVoucher = this._setActiveVoucher.bind(this);
    this._redeemSticker = this._redeemSticker.bind(this);
    this._advancedSubmit = this._advancedSubmit.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
    printerSettings: PropTypes.object,
  };

  _setActiveVoucher(activeVoucher) {
    this.setState({ activeVoucher });
  }

  _redeemSticker(values, setSubmitting) {
    const { activeVoucher } = this.state;

    console.log({ values, activeVoucher });

    const data = {
      claimingCrewMemberId: activeVoucher.crewMember.id,
      parkingStickerId: activeVoucher.parkingStickerId,
      codeRangeStart: values.stickerCode,
      codeRangeStop: values.stickerCode,
    };

    claimParkingStickers(this.props.event.id, data)
      .then((response) => {
        this.setState({
          activeVoucher: undefined,
        });
        defaultSuccess('Stickers Registered');
        confetti(true);
      })
      .catch((e) => {
        ajaxErrorHandler(e);
        setSubmitting(false);
      });
  }

  _advancedSubmit(values, setSubmitting) {
    const data = {
      claimingCrewMemberId: this.state.crewMember.id,
      parkingStickerId: values.parkingStickerId,
      codeRangeStart: values.codeRangeStart,
      codeRangeStop: values.codeRangeStop ? values.codeRangeStop : values.codeRangeStart,
    };

    claimParkingStickers(this.props.event.id, data)
      .then((response) => {
        this.setState({
          crewMember: undefined,
        });
        defaultSuccess('Stickers Registered');
      })
      .catch((e) => {
        ajaxErrorHandler(e);
        setSubmitting(false);
      });
  }

  render() {
    const { event, printerSettings } = this.props;
    const { activeVoucher, crewMember } = this.state;
    return (
      <div>
        <ParkingStickersVouchersSearchForm
          event={event}
          activeVoucher={activeVoucher}
          printerSettings={printerSettings}
          setActiveVoucher={this._setActiveVoucher}
          startManualHandout={(crewMember) => this.setState({ crewMember })}
        />

        {crewMember && (
          <ModalToBody>
            <div
              className="modal fade show"
              id="m_modal_4"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              style={{
                display: 'block',
                zIndex: '1039',
              }}
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Advanced Handout Sticker
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.setState({ crewMember: undefined })}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>

                  <ParkingStickersVouchersAdvancedForm
                    onSubmit={this._advancedSubmit}
                    event={event}
                    crewMember={crewMember}
                  />
                </div>
              </div>
            </div>

            <div
              className={'modal-backdrop fade show'}
              style={{
                display: 'block',
                zIndex: '1038',
              }}
            />
          </ModalToBody>
        )}

        {activeVoucher && (
          <ModalToBody>
            <div
              className="modal fade show"
              id="m_modal_4"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              style={{
                display: 'block',
                zIndex: '1039',
              }}
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Hand Out Sticker
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this._setActiveVoucher(undefined)}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>

                  <ParkingStickersVouchersStickerForm voucher={activeVoucher} onSubmit={this._redeemSticker} />
                </div>
              </div>
            </div>

            <div
              className={'modal-backdrop fade show'}
              style={{
                display: 'block',
                zIndex: '1038',
              }}
            />
          </ModalToBody>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = function (state) {
  return {
    event: selectEvent(state),
    printerSettings: printerSettings(state),
  };
};

const ParkingStickersVouchersSearch = connect(mapStateToProps, mapDispatchToProps)(_ParkingStickersVouchersSearch);

export default ParkingStickersVouchersSearch;
